export default __webpack_public_path__ + "static/media/chromelogo.02d66b84.png";